/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { ClientNfsShareService } from '../client-nfs-share/client-nfs-share.service';
import { NfsShareService } from '../nfs-share.service';
import { NfsShareStrService } from '../nfs-share-str.service';
import { CopyFromNfsShareComponent } from './copy-from-nfs-share.component';

@NgModule({
    declarations: [CopyFromNfsShareComponent],
    exports: [CopyFromNfsShareComponent],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [
        NfsShareStrService,
        NfsShareService,
        ClientNfsShareService,
    ],
})
export class CopyFromNfsShareModule { }
